var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2_83)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.4567,
    y: 8.5332,
    width: 49.7,
    height: 49.7,
    rx: 24.85,
    fill: "#9DCCED"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_83)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5516 27.7579V39.0083C24.5516 39.7316 24.9305 40.3859 25.5619 40.7533L35.3084 46.3785C35.9283 46.7344 36.6975 46.7344 37.3174 46.3785L47.0639 40.7533C47.6838 40.3974 48.0742 39.7316 48.0742 39.0083V27.7579C48.0742 27.0347 47.6953 26.3803 47.0639 26.013L37.3174 20.3878C36.6975 20.0319 35.9283 20.0319 35.3084 20.3878L25.5619 26.013C24.942 26.3688 24.5631 27.0347 24.5631 27.7579H24.5516Z",
    fill: "#213147"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4304 35.5644L37.0413 39.3758C37.0069 39.4791 37.0069 39.5939 37.0413 39.7087L39.4292 46.2638L42.1959 44.668L38.8781 35.5644C38.7978 35.3578 38.5108 35.3578 38.4304 35.5644Z",
    fill: "#12AAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2202 29.1585C41.1398 28.9519 40.8528 28.9519 40.7725 29.1585L39.3834 32.9699C39.3489 33.0732 39.3489 33.188 39.3834 33.3028L43.2981 44.0366L46.0647 42.4409L41.2202 29.17V29.1585Z",
    fill: "#12AAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3069 20.8126C36.3758 20.8126 36.4446 20.8356 36.502 20.87L47.0407 26.9544C47.167 27.0233 47.2358 27.161 47.2358 27.2988V39.4676C47.2358 39.6054 47.1555 39.7431 47.0407 39.812L36.502 45.8964C36.4446 45.9308 36.3758 45.9538 36.3069 45.9538C36.238 45.9538 36.1691 45.9308 36.1117 45.8964L25.5731 39.812C25.4468 39.7431 25.3779 39.6054 25.3779 39.4676V27.2873C25.3779 27.1496 25.4583 27.0118 25.5731 26.9429L36.1117 20.8585C36.1691 20.8241 36.238 20.8011 36.3069 20.8011V20.8126ZM36.3069 19.0332C35.928 19.0332 35.5607 19.125 35.2163 19.3202L24.6776 25.4046C24.0003 25.7949 23.587 26.5067 23.587 27.2873V39.4561C23.587 40.2368 24.0003 40.9485 24.6776 41.3388L35.2163 47.4232C35.5492 47.6184 35.928 47.7102 36.3069 47.7102C36.6857 47.7102 37.0531 47.6184 37.3975 47.4232L47.9361 41.3388C48.6134 40.9485 49.0267 40.2368 49.0267 39.4561V27.2873C49.0267 26.5067 48.6134 25.7949 47.9361 25.4046L37.386 19.3202C37.0531 19.125 36.6742 19.0332 36.2954 19.0332H36.3069Z",
    fill: "#9DCCED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.327 44.0481L30.3028 41.3848L32.2544 43.0034L30.4291 44.6795L29.327 44.0481Z",
    fill: "#213147"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4117 26.4264H32.7369C32.5417 26.4264 32.3581 26.5527 32.2892 26.7364L26.5607 42.441L29.3273 44.0367L35.6413 26.7364C35.6987 26.5756 35.584 26.4149 35.4232 26.4149L35.4117 26.4264Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0952 26.4264H37.4204C37.2252 26.4264 37.0416 26.5527 36.9727 26.7364L30.4291 44.6681L33.1958 46.2638L40.3134 26.7364C40.3708 26.5756 40.256 26.4149 40.0952 26.4149V26.4264Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2_83",
    x: 0.956665,
    y: 0.833203,
    width: 70.7,
    height: 70.7,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_83"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_83",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_83"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.9567,
    y: 19.0332,
    width: 28.7,
    height: 28.7,
    rx: 14.35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArb);
export default __webpack_public_path__ + "static/media/arb.c8613e43968bb92a2e971ef45b2acce6.svg";
export { ForwardRef as ReactComponent };